import { MiniCartFragment } from '@/hooks/MiniCart/miniCartFragments.gql';
import { gql } from '@apollo/client';

export { MiniCartFragment };

export const MINI_CART_QUERY = gql`
  query MiniCartQuery($cartId: String!) {
    cart(cart_id: $cartId) {
      id
      ...MiniCartFragment
    }
  }
  ${MiniCartFragment}
`;

export const REMOVE_ITEM_MUTATION = gql`
  mutation RemoveItemForMiniCart($cartId: String!, $itemId: ID!) {
    removeItemFromCart(input: { cart_id: $cartId, cart_item_uid: $itemId }) {
      cart {
        id
        ...MiniCartFragment
      }
    }
  }
  ${MiniCartFragment}
`;

export const UPDATE_ITEM_MUTATION = gql`
  mutation updateItemInCart($cartId: String!, $itemId: ID!, $quantity: Float!) {
    updateCartItems(input: { cart_id: $cartId, cart_items: [{ cart_item_uid: $itemId, quantity: $quantity }] }) {
      cart {
        id
        ...MiniCartFragment
      }
    }
  }
  ${MiniCartFragment}
`;

export default {
  miniCartQuery: MINI_CART_QUERY,
  removeItemMutation: REMOVE_ITEM_MUTATION,
};
